"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionableCard = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var FlexView_1 = require("../FlexView");
var Icon_1 = require("../Icon");
require("./actionableCard.css");
var ActionableCard = function (_a) {
    var title = _a.title, children = _a.children, onClick = _a.onClick;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "actionable-card", onClick: onClick }, { children: (0, jsx_runtime_1.jsxs)(FlexView_1.FlexView, __assign({ hAlignContent: "between", vAlignContent: "center" }, { children: [(0, jsx_runtime_1.jsxs)(FlexView_1.FlexView.Item, __assign({ xs: 11 }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "actionable-card-title" }, { children: title })), children ? (0, jsx_runtime_1.jsx)("div", __assign({ className: "actionable-card-children" }, { children: children })) : null] })), (0, jsx_runtime_1.jsx)(FlexView_1.FlexView.Item, __assign({ xs: 0.5, className: "actionable-card-arrow" }, { children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { icon: "icon_right", size: "md" }) }))] })) })));
};
exports.ActionableCard = ActionableCard;
//# sourceMappingURL=ActionableCard.js.map